import { theme as antdTheme, type ThemeConfig } from "antd"
import type { ThemeMode } from "~/store/theme"

export const APP_THEME = {
  borderRadius: 12,
  colorPrimary: "#ff6112",
  cyan: "#059669",
} as const

const sharedThemeToken: ThemeConfig["token"] = {
  borderRadius: APP_THEME.borderRadius,
  colorLink: APP_THEME.colorPrimary,
  colorPrimary: APP_THEME.colorPrimary,
  cyan: APP_THEME.cyan,
}

const lightThemeToken: ThemeConfig["token"] = {
  ...sharedThemeToken,
  "cyan-1": "#ecf8f7",
  cyan1: "#ecf8f7",
  colorBgBase: "#fff",
  colorTextBase: "#333",
}

const darkThemeToken: ThemeConfig["token"] = {
  ...sharedThemeToken,
  colorBgBase: "#000",
  colorTextBase: "#fff",
}

export const getAppThemeCssVarKey = (mode: ThemeMode) =>
  mode === "dark" ? "app-dark" : "app-light"

export const buildAppTheme = (mode: ThemeMode): ThemeConfig => {
  return {
    algorithm:
      mode === "dark" ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    cssVar: {
      key: getAppThemeCssVarKey(mode),
    },
    token: mode === "dark" ? darkThemeToken : lightThemeToken,
    components: {
      Button: {
        colorLink: "var(--ant-color-primary)",
        colorLinkHover: "var(--ant-color-primary-hover)",
        colorLinkActive: "var(--ant-color-primary-active)",
      },
      Segmented: {
        borderRadiusSM: 12,
        borderRadiusXS: 12,
      },
      Typography: {
        titleMarginBottom: 0,
        titleMarginTop: 0,
      },
      Alert: { withDescriptionPadding: "12px 16px" },
    },
  }
}
